export default __webpack_public_path__ + "static/media/icn-close-square.23af2ca3.svg";